import { render, staticRenderFns } from "./StudentLearningFaceDetection.vue?vue&type=template&id=66426aeb&scoped=true"
import script from "./StudentLearningFaceDetection.vue?vue&type=script&lang=js"
export * from "./StudentLearningFaceDetection.vue?vue&type=script&lang=js"
import style0 from "./StudentLearningFaceDetection.vue?vue&type=style&index=0&id=66426aeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66426aeb",
  null
  
)

export default component.exports